'use client';

import { useBanners } from '@/entities/banner/api/query';
import { Link } from '@/i18n/navigation';
import { Locale } from '@/shared/types/locale';
import { Container } from '@/shared/ui';
import { Box, Image } from '@chakra-ui/react';
import { useLocale } from 'next-intl';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { heroSwiperConfig } from '../config/swiper.config';
import BannerSkeleton from './banner-skeleton';

export function HeroBanner() {
  const locale = useLocale() as Locale;
  const { data, isLoading } = useBanners();

  if (isLoading) {
    return <BannerSkeleton />;
  }

  const filteredBanners = data?.map((banner) => {
    const content = (
      <Image
        src={banner.image[locale]}
        alt={banner.title[locale]}
        objectFit="cover"
        w="full"
        h="full"
      />
    );
    return (
      <SwiperSlide
        key={banner.id}
        style={{
          maxWidth: '540px',
        }}
      >
        <Box h="130px" w="full" rounded="xl" overflow="hidden">
          {banner.url ? (
            <Link href={banner.url} target="_blank">
              {content}
            </Link>
          ) : (
            content
          )}
        </Box>
      </SwiperSlide>
    );
  });

  return (
    <Container>
      <Swiper {...heroSwiperConfig} modules={[Autoplay]} autoHeight>
        {filteredBanners}
      </Swiper>
    </Container>
  );
}
